import React, { useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { Sidebar } from "../components/Sidebar";
import { PageHeader, LoadingState, ErrorState } from "../components/UI";
import { useRoomData } from "../components/RoomPage/hooks/useRoomData";
import { RoomInfo, ContentTabs } from "../components/RoomPage";
import { EditRoomModal } from "../components/Room/EditRoomModal";

function RoomPage() {
  const { hotel_id: hotelId, id: roomId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const { room, hotel, modules, showers, heartbeats, batteryHistory, statusLogs, moduleLogs, currentBattery, loading, error, updateRoom, refetch } = useRoomData(hotelId, roomId);

  const initialTab = searchParams.get("tab") || undefined;

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleEditRoom = () => {
    setIsEditModalOpen(true);
  };

  const handleModalClose = () => {
    setIsEditModalOpen(false);
  };

  const handleRoomUpdate = () => {
    refetch();
  };

  if (loading) {
    return <LoadingState message="Chargement des données de la chambre..." />;
  }

  if (error) {
    return <ErrorState error={error} />;
  }

  if (!room) {
    return <ErrorState error="Chambre non trouvée" />;
  }

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 p-6 overflow-auto">
        <PageHeader
          title={`Chambre ${room.room_nb}${hotel ? ` - ${hotel.name}` : ""}`}
          onGoBack={handleGoBack}
          actions={
            <button onClick={handleEditRoom} className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors">
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
              Modifier
            </button>
          }
        />

        <div className="space-y-6">
          <RoomInfo room={room} hotel={hotel} module={modules?.[0]} />
          <ContentTabs modules={modules} showers={showers} heartbeats={heartbeats} batteryHistory={batteryHistory} statusLogs={statusLogs} moduleLogs={moduleLogs} currentBattery={currentBattery} onRefetch={refetch} initialTab={initialTab} />
        </div>

        {/* Modal d'édition */}
        {isEditModalOpen && <EditRoomModal isOpen={isEditModalOpen} onClose={handleModalClose} room={room} modules={modules} hotelId={hotelId} onRoomUpdated={handleRoomUpdate} />}
      </div>
    </div>
  );
}

export default RoomPage;
